/*
 * @Author: Mufaddal Jamali
 * @Date: 2020-02-24 15:49:21
 * @Last Modified by: Mufaddal Jamali
 * @Last Modified time: 2020-10-20 11:22:02
 */

import React, { Component } from "react";
import Slot from "../components/slot/slot";
import "antd/dist/antd.css";
import { DatePicker } from "antd";
import $ from "jquery";
import moment from "moment";
import { DataService } from "../services/data.service";
import { Empty } from "antd";

import "moment/locale/es";
import { ConfigProvider } from "antd";
import esES from "antd/es/locale/es_ES";
import enUS from "antd/es/locale/en_US";
import Loader from "../components/loader/loader";
import * as handler from "../components/utils/handler"
const queryString = require("query-string");

class Slots extends Component {
  slotsToShowCount = window["app-config"].slotsToShowCount;
  runApp = window["app-config"].runApp;
  defaultAheadDays = window["app-config"].defaultAheadDays;
  defaultLanguage = window["app-config"].defaultLang;
  color = window["app-config"].ui.slotScreen;
  slotColor = window["app-config"].ui.slotScreen.fontColor;
  selectedSlotColor = window["app-config"].ui.slotScreen.slotSelectionColor;
  defaultSlotColor = window["app-config"].ui.slotScreen.defaultFontColor;
  defaultTheme =
  window["app-config"].applicationProperties.defaultTheme;
  enableCategorySelection = window["app-config"].enableCategorySelection;

  state = {
    selectedDate: moment(new Date()).format("YYYY-MM-DD"),

    nextDates: [],
    appointmentSlots: [],
    dataLoaded: false,
    isCurrentDateSlots: false,
    futureAppointmentDays:
      this.props.branchDetails().length > 0 &&
      this.props.branchDetails()[0]?.FutureDaysForAppointment != ""
        ? this.props.branchDetails()[0]?.FutureDaysForAppointment
        : this.defaultAheadDays,
    lang: {},
  };

  dataService = new DataService();


  componentDidMount() {
    this.setState({lang: handler.setTranslations()});
    this.props.setHeading(null);
    this.props.hideBtnNext();
    this.getDateTimeSlots(this.state.selectedDate);

  }

  onDateChange =  (date, dateString) => {
    this.props.hideBtnNext();
    this.setState({ dataLoaded: false, selectedDate: date });
    let formattedDate = moment(date === null ? new Date() : date).format("YYYY-MM-DD")
    this.getDateTimeSlots(formattedDate);
  };



  getDateTimeSlots = async (date) => {
    var dateGiven = moment(date);
    var DAY = dateGiven.day();

    DAY = DAY == 0 ? 7 : DAY;

    var currContext = this;

       if(this.enableCategorySelection === true){
      try {
    console.log(JSON.parse(localStorage.getItem("filterdata")),"lslsl");
    let branchid = JSON.parse(localStorage.getItem("filterdata"));
    var response = await this.dataService.getDateTimeSlots(
      branchid.BranchID,
      this.props.category(),
      // this.state.selectedDate,
      date,
      this.defaultAheadDays.toString()
    );
    if (response.data.error !== undefined && response.data.error === true) {
      this.setState({ appointmentSlots: undefined, dataLoaded: true });
    } else if (response.data.appointmentSlots !== null) {
      var appointmentSlots = response.data.appointmentSlots.slice(
        0,
        this.slotsToShowCount < 0 || this.slotsToShowCount > 7
          ? 7
          : this.slotsToShowCount
      );
      this.setState({
        appointmentSlots: appointmentSlots,
        dataLoaded: true,
      });
    } else {
      this.setState({ appointmentSlots: [], dataLoaded: true });
    }
    var slotValue = false;
    this.state.appointmentSlots.forEach(function (value, key) {
      if (value.DayID == DAY) {
        if (value.slotDetail.length == 0) {
          slotValue = true;
        }
      }
    });
  } catch (error) {
    console.log(error.message);
    if (
      error.message.includes("timeout") ||
      error.message.includes("ERR_CONNECTION")
    ) {
      this.setState({ appointmentSlots: undefined, dataLoaded: true });
    } else {
      this.setState({ appointmentSlots: [], dataLoaded: true });
    }
  }
}else{
  try {
    var response = await this.dataService.getDateTimeSlots(
      this.props.branchDetails()[0].BranchID,
      this.props.category(),
      // this.state.selectedDate,
      date,
      this.defaultAheadDays.toString()
    );
    if (response.data.error !== undefined && response.data.error === true) {
      this.setState({ appointmentSlots: undefined, dataLoaded: true });
    } else if (response.data.appointmentSlots !== null) {
      var appointmentSlots = response.data.appointmentSlots.slice(
        0,
        this.slotsToShowCount < 0 || this.slotsToShowCount > 7
          ? 7
          : this.slotsToShowCount
      );
      this.setState({
        appointmentSlots: appointmentSlots,
        dataLoaded: true,
      });
    } else {
      this.setState({ appointmentSlots: [], dataLoaded: true });
    }
    var slotValue = false;
    this.state.appointmentSlots.forEach(function (value, key) {
      if (value.DayID == DAY) {
        if (value.slotDetail.length == 0) {
          slotValue = true;
        }
      }
    });
  } catch (error) {
    console.log(error.message);
    if (
      error.message.includes("timeout") ||
      error.message.includes("ERR_CONNECTION")
    ) {
      this.setState({ appointmentSlots: undefined, dataLoaded: true });
    } else {
      this.setState({ appointmentSlots: [], dataLoaded: true });
    }
  }
}
  }

  render() {
    let theme = queryString.parse(window.location.search).theme == undefined ? this.defaultTheme : queryString.parse(window.location.search).theme;
    var currContext = this;
    $(document).ready(function () {
      $(".time").click(function () {
        $(".time").each((i, d) => {
          $(d).css("border-color", "#eee");
          $(d).css("color", currContext.defaultSlotColor);
        });
        
       theme == "dark" ? $(this).css("border-color",  "#f4741d") : $(this).css("border-color",  currContext.selectedSlotColor);
        // #f4741d
        theme == "dark" ? $(this).css("color",  "#f4741d") : $(this).css("color",  currContext.slotColor);
        // $(this).css("color",  currContext.slotColor);

        let slotDate = $(
          $(this).closest($(".sl__modal_calendar-col")).first()[0].innerHTML
        ).attr("date");

        let slotId = $(this).attr("value");
        let time = $(this).attr("time");
        currContext.props.dateTimeSlot(slotId, slotDate, time);
      });
    });

    if (this.state.dataLoaded === false) {
      return (
        <div className="sl__modal-inner">
          <div className="sl__modal--content">
            <h2 style={{ color: this.color.headingColor }}>
              {this.state.lang.WhenDoYouMakeAppointment}
            </h2>

            <div className="sl__modal_calendar-row">
              <div className="sl__modal_calendar-col header">
                <label className="sl__modal_form--label">
                  {this.state.lang.SelectDate}
                </label>
                <div className="sl__modal_calendar_input">
                  <ConfigProvider
                    locale={localStorage.getItem("lang") === "es" ? esES : enUS}
                  >
                    <DatePicker
                      onChange={this.onDateChange}
                      defaultValue={moment(this.state.selectedDate)}
                      format={"DD-MMM-YYYY"}
                      disabledDate={(current) => {
                        return (
                          moment().add(-1, "days") >= current ||
                          moment().add(
                            this.state.futureAppointmentDays,
                            "days"
                          ) <= current
                        );
                      }}
                      allowClear={false}
                    />
                  </ConfigProvider>
                </div>
              </div>
            </div>

            <Loader />
          </div>
        </div>
      );
    } else if (
      this.state.appointmentSlots.length > 0 &&
      this.state.appointmentSlots !== null
    ) {
      return (
        <div className="sl__modal-inner">
          <div className="sl__modal--content">
            <h2 style={{ color: this.color.headingColor }}>
              {this.state.lang.WhenDoYouMakeAppointment}
            </h2>

            <div className="sl__modal_calendar-row">
              <div className="sl__modal_calendar-col header">
                <label className="sl__modal_form--label">
                  {this.state.lang.SelectDate}
                </label>
                <div className="sl__modal_calendar_input">
                  <ConfigProvider
                    locale={localStorage.getItem("lang") === "es" ? esES : enUS}
                  >
                    <DatePicker
                      onChange={this.onDateChange}
                      defaultValue={moment(this.state.selectedDate)}
                      format={"DD-MMM-YYYY"}
                      disabledDate={(current) => {
                        return (
                          moment().add(-1, "days") >= current ||
                          moment().add(
                            this.state.futureAppointmentDays,
                            "days"
                          ) <= current
                        );
                      }}
                      allowClear={false}
                    />
                  </ConfigProvider>
                  {this.state.isCurrentDateSlots === true ? (
                    <p style={{ marginTop: "10px" }}>{this.state.lang.NoSlotsAvailable}</p>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>

            <div className="sl__modal_calendar-row">
              {this.state.appointmentSlots !== null &&
              this.state.appointmentSlots.length > 0 ? (
                this.state.appointmentSlots.map((data, index) => {
                  return (
                    <Slot
                      date={data.Date}
                      key={index}
                      timeSlots={data.slotDetail}
                      lang = {this.state.lang}
                    ></Slot>
                  );
                })
              ) : (
                <Empty description={this.state.lang.NoSlotsAvailableMsg} />
              )}
            </div>
          </div>
        </div>
      );
    } else if (this.state.appointmentSlots === undefined) {
      return (
        <div className="sl__modal-inner">
          <div className="sl__modal--content">
            <h2 style={{ color: this.color.headingColor }}>
              {this.state.lang.WhenDoYouMakeAppointment}
            </h2>
            <div className="sl__modal_calendar-row">
              <div className="sl__modal_calendar-col header">
                <label className="sl__modal_form--label">
                  {this.state.lang.SelectDate}
                </label>
                <div className="sl__modal_calendar_input">
                  <ConfigProvider
                    locale={localStorage.getItem("lang") === "es" ? esES : enUS}
                  >
                    <DatePicker
                      onChange={this.onDateChange}
                      defaultValue={moment(this.state.selectedDate)}
                      format={"DD-MMM-YYYY"}
                      disabledDate={(current) => {
                        return (
                          moment().add(-1, "days") >= current ||
                          moment().add(
                            this.state.futureAppointmentDays,
                            "days"
                          ) <= current
                        );
                      }}
                      allowClear={false}
                    />
                  </ConfigProvider>
                </div>
              </div>
            </div>
            <div className="sl__modal--row">
              <Empty description={this.state.lang.ServerNotResponding}></Empty>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="sl__modal-inner">
          <div className="sl__modal--content">
            <h2 style={{ color: this.color.headingColor }}>
              {this.state.lang.WhenDoYouMakeAppointment}
            </h2>
            <div className="sl__modal_calendar-row">
              <div className="sl__modal_calendar-col header">
                <label className="sl__modal_form--label">
                  {this.state.lang.SelectDate}
                </label>
                <div className="sl__modal_calendar_input">
                  <ConfigProvider
                    locale={localStorage.getItem("lang") === "es" ? esES : enUS}
                  >
                    <DatePicker
                      onChange={this.onDateChange}
                      defaultValue={moment(this.state.selectedDate)}
                      format={"DD-MMM-YYYY"}
                      disabledDate={(current) => {
                        return (
                          moment().add(-1, "days") >= current ||
                          moment().add(
                            this.state.futureAppointmentDays,
                            "days"
                          ) <= current
                        );
                      }}
                      allowClear={false}
                    />
                  </ConfigProvider>
                </div>
              </div>
            </div>
            <div className="sl__modal--row">
              <Empty description={this.state.lang.NoSlotsAvailableMsg}></Empty>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default Slots;
